import { render, staticRenderFns } from "./planoAnual.vue?vue&type=template&id=d4ca9a18"
import script from "./planoAnual.vue?vue&type=script&lang=js"
export * from "./planoAnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports